import React, { useContext, useEffect, useRef, useState } from 'react'
import Select from 'react-select';
import { Context } from '../Context/Context';

const SelectAcctModal = ({ setOpenSelectAcct, openSelectAcct, invoiceDetails }) => {

    const ModalRef = useRef()

    const { currencyLogos, handleViewInvoice, generatePDF, setShowPDFContent } = useContext(Context)
    const accounts = JSON.parse(localStorage.getItem('UserAcctDetails'))

    const [selectedCurrency, setSelectedCurrency] = useState('');
    const [selectedAccount, setSelectedAccount] = useState('');
    const [loading, setLoading] = useState(false);
    // const [SMScreen, setSMScreen] = useState(window.innerWidth < 850);

    // useEffect(() => {
    //     const handleResize = () => {
    //         setSMScreen(window.innerWidth < 850)
    //     }

    //     window.addEventListener('resize', handleResize)

    //     return () => window.removeEventListener('resize', handleResize)
    // }, [])

    useEffect(() => {
        const saved = JSON.parse(localStorage.getItem('selectedCurrency'));
        if (saved?.value) {
            setSelectedCurrency(saved.value);
        } else if (accounts?.length > 0) {
            setSelectedCurrency(accounts[0].currency);
        }
    }, [accounts]);


    const closeModal = (e) => {
        if (ModalRef.current === e.target) {
            setOpenSelectAcct(false)
        }
    }
    const handleDownload = (id) => {
        localStorage.setItem('invoiceData', JSON.stringify(id));
    };

    const currencyOptions = accounts.map((acct) => ({
        value: acct.currency,
        label: (
            <div className="flex items-center gap-2">
                <img src={currencyLogos[acct.currency]} alt={acct.currency} className="w-5 h-4" />
                <span>{acct.currency}</span>
            </div>
        )
    }));

    const selectedOption = currencyOptions.find(opt => opt.value === selectedCurrency);

    useEffect(() => {
        if (selectedCurrency) {
            const acct = accounts.find((a) => a.currency === selectedCurrency);
            // Compare by currency or id, not object reference
            if (acct && (!selectedAccount || acct.currency !== selectedAccount.currency)) {
                setSelectedAccount(acct);
                localStorage.setItem('userSelectedInvoiceAcct', JSON.stringify(acct))
            }
        }
    }, [selectedCurrency, accounts, selectedAccount]);

    const customStyles = {
        indicatorSeparator: () => ({
            display: 'none',
        }),
        control: (base) => ({
            ...base,
            borderColor: '#F3F0F7',
            borderWidth: '1.2px',
            boxShadow: '0 1px 2px 0 #1D1C1F0D',
            borderRadius: '10px',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 999,
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: '0 4px', // adjust this value to reduce the space
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused ? '#F3F0F7' : 'white',
            color: 'black',
            cursor: 'pointer',
        }),
    }

    const handleDownloadPDF = async () => {
        handleDownload(invoiceDetails);
        setShowPDFContent(true);
        setLoading(true);

        await new Promise((resolve) => setTimeout(resolve, 4500));
        await generatePDF();

        setShowPDFContent(false);
        setLoading(false);
        handleViewInvoice();
        setOpenSelectAcct(false);
    };

    return (
        <div>
            {openSelectAcct && (
                <div onClick={closeModal} ref={ModalRef} className='fixed flex sa:items-center items-end justify-center z-50  bg-black bg-opacity-30 inset-0'>
                    <div className='sm:w-[70%] sa:mx-5 lg:w-[45%] 2xl:w-[26.5%] text-[20px] w-full bg-white h-[30vh] sa:h-auto sa:rounded-[20px] flex flex-col items-center justify-center p-6'>
                        <p className='text-center'>Select which account details to send.</p>

                        <Select
                            styles={customStyles}
                            value={selectedOption}
                            onChange={(selected) => setSelectedCurrency(selected.value)}
                            options={currencyOptions}
                            className="react-select-container w-[120px]"
                            classNamePrefix="react-select"
                        />

                        <button
                            className={`p-3 rounded-lg sa:w-[25%] w-full mx-auto mt-5 text-[#ffffff] py-[10px] px-4 text-[14px] ${loading ? 'bg-[#bc9cf8] cursor-not-allowed' : 'bg-[#491597]'}`}
                            onClick={handleDownloadPDF}
                            disabled={loading}
                        >
                            {loading ? 'Generating...' : 'Done'}
                        </button>
                    </div>
                </div >
            )}
        </div>
    )
}

export default SelectAcctModal